export const LOCAL_STORAGE_KEY = "filterPerksByLocation"

class LocationTags {
  list() {
    return getLocationTagsFromLocalStorage()
  }

  set(arr: string[]) {
    setLocationTagsToLocalStorage(arr)
    return arr
  }

  removeOldFromLocalStorage(tags: {uuid: string}[]) {
    const toRemove = this.list().filter((test) => {
      let found = false
      tags.forEach((tag) => {
        if (tag.uuid === test) {
          found = true
        }
      })
      return found
    })

    toRemove.forEach((tag) => this.remove(tag))
  }

  add(toAdd: string) {
    const arr = [...getLocationTagsFromLocalStorage(), toAdd]
    setLocationTagsToLocalStorage(arr)
    return arr
  }

  remove(toRemove: string) {
    const arr = [...getLocationTagsFromLocalStorage()].filter((t) => t !== toRemove)
    setLocationTagsToLocalStorage(arr)
    return arr
  }

  clear() {
    setLocationTagsToLocalStorage([])
    return getLocationTagsFromLocalStorage()
  }
}

export default new LocationTags()

function setLocationTagsToLocalStorage(arr: string[]) {
  window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(arr))
}

function getLocationTagsFromLocalStorage(): string[] {
  try {
    const tags = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY))
    if (Array.isArray(tags)) {
      return tags
    }
  } catch (e) {
    /* no-op */
  }
  return []
}
